import { Link } from "react-router-dom";

import SEO from "../components/SEO";

export default function DeleteAccount() {
  return (
    <main className="mx-auto max-w-3xl px-5 py-12 text-white sm:px-6">
      <SEO title="Delete your account" description="Delete or request deletion of your Competition Checker account and associated data." path="/delete-account" />
      <p className="overline text-[var(--cc-gold)]">Account privacy</p>
      <h1 className="mt-3 font-display text-3xl font-semibold">Delete your Competition Checker account</h1>
      <p className="mt-5 text-sm leading-relaxed text-white/75">
        You do not need the mobile app installed to request deletion. Deleting a Competition Checker
        account does not delete your Google account.
      </p>
      <section className="mt-8 border-t border-white/15 pt-6">
        <h2 className="font-display text-xl font-semibold">Delete it yourself</h2>
        <p className="mt-3 text-sm leading-relaxed text-white/70">
          For a password account, sign in on this website, open Account, then Privacy &amp; data,
          and select Delete account. In the Android app, open Account and select Delete account.
          Password accounts confirm with their current password. Google-linked accounts can
          confirm with a recent Google sign-in on the website or in the Android app.
        </p>
        <Link to="/signin" className="mt-4 inline-flex min-h-11 items-center rounded bg-[var(--cc-gold)] px-4 text-sm font-semibold text-[var(--cc-navy)]">
          Sign in to your account
        </Link>
      </section>
      <section className="mt-8 border-t border-white/15 pt-6">
        <h2 className="font-display text-xl font-semibold">Request help without the app</h2>
        <p className="mt-3 text-sm leading-relaxed text-white/70">
          Email us from the address associated with your account. We will verify account ownership
          before deleting any data. Do not send us your password, a Google ID token, or a verification code.
        </p>
        <a className="mt-4 inline-flex min-h-11 items-center text-sm font-semibold text-[var(--cc-gold)] underline"
          href="mailto:support@competitionchecker.com?subject=Competition%20Checker%20account%20deletion%20request">
          Request account deletion by email
        </a>
      </section>
      <section className="mt-8 border-t border-white/15 pt-6">
        <h2 className="font-display text-xl font-semibold">What happens to your data</h2>
        <p className="mt-3 text-sm leading-relaxed text-white/70">
          Deletion revokes sessions, removes your email and optional account data including favourite
          operators and privacy choices, and leaves only a pseudonymous security tombstone and limited
          audit information where justified. See our <Link className="text-[var(--cc-gold)] underline" to="/privacy-policy">Privacy Policy</Link>
          {" "}for retention and rights details.
        </p>
      </section>
    </main>
  );
}
